<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div id="background" style="height: 100%;
    width: 100vw;
    position:fixed;
    background: url(/static/images/bolang/jf_bg.png) no-repeat;
    background-attachment: fixed;
    background-size:cover;
    background-position: bottom;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;">
      <img src="/static/images/bolang/logo.png" alt=""
        style="width: 30%;height: auto;position: absolute;top: 6%;right: 35%;">
      <div v-if="!showRule"
        style="width: 100%;position: absolute;position: absolute;top: 16%;text-align: center;display: flex;flex-direction: column;align-items: center;">
        <img src="/static/images/bolang/score_bg.png" style="width: 90%;height: auto;" />
        <div
          style="width: 90%;position: absolute;position: absolute;top: 9%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <img src="/static/images/bolang/anti_query.png" width="52%" />
          <div style="width: 90%;text-align: left;display: flex;flex-direction: column;">
            <img src="/static/images/bolang/antiresult.png" width="20%" style="margin-top: 30px;margin-left: 15px;" />
            <span style="margin-top: 10px;margin-left: 15px;font-size: 13px;">{{ this.antiCodeResult }}</span>
            <img src="/static/images/bolang/line.png" width="90%" style="margin-top: 6px;margin-left: 15px;" />
            <span style="margin-top: 10px;margin-left: 15px;color:rgb(112,115,119);font-size: 12px;" v-html="antiresult"></span>
          </div>
          <img v-if="getGift && showScore" src="/static/images/bolang/lingqu_50_jf.png"
            style="width: 60%;height: auto;margin-top: 30px;" />
          <img v-if="!getGift" src="/static/images/bolang/lingqu_jf.png"
            style="width: 60%;height: auto;margin-top: 30px;" />

          <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
                                        <input type="button" value="进入商城 >" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border: 0px;
                                                            margin-top: 25px;
                                                            border-radius: 20px;
                                                            background: linear-gradient(to bottom,rgb(81,91,167), rgb(52,60,125),rgb(81,91,167));
                                                            width: 200px;height: 40px;" />
                                    </script>
          </wx-open-launch-weapp>


          <div id="bottom_bar" style="text-align: center;height: 20px;width: 100%;margin-top: 10px;">
            <span style="text-align: center;text-decoration: underline;color: rgb(33, 33, 34);font-size: 13px;"
              @click="showActivityRule">规则说明</span>
          </div>


        </div>
      </div>







      <div v-if="showRule" @click="showActivity"
        style="width: 100%;position: absolute;position: absolute;top: 16%;text-align: center;display: flex;flex-direction: column;align-items: center;">
        <img src="/static/images/bolang/rulecontent.png" style="width: 90%;height: auto;" />
        <div
          style="width: 90%;position: absolute;position: absolute;top: 9%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <img src="/static/images/bolang/ruletitle.png" width="30%" />
          <div style="width: 86%;text-align: left;font-size: 15px;line-height: 2.5;margin-top: 30px;text-indent: -10;">
            <div style="display: flex;text-align: left;">
              <span style="margin-right: 3px;">1.</span>购买境生之源产品有防伪标签，可扫码查询真伪。
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">2.</span>首次购买境生之源产品点击添加企微可参与领取50积分活动,积分可用于兑换产品。
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">3.</span>活动积分仅产品第一次扫码有效，重复扫码无积分。
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">4.</span>活动最终解释权归境生之源所有。
            </div>
          </div>

        </div>
      </div>






    </div>


  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.verification-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.verification-item {
  display: flex;
  align-items: center;
  border: 1px solid rgb(124, 136, 192);
  /* Border color */
  border-radius: 25px;
  overflow: hidden;
  width: 240px;
  /* Adjust width as needed */
  background-color: white;
}

.verification-text {
  flex: 1;
  padding: 10px 0px 10px 20px;
  font-size: 13px;
  color: rgb(145, 151, 164);
  border: 0px;
  /* Text color */
  text-align: left;
}

.verification-button {
  background: linear-gradient(to bottom, #4A4F9E, #2E2F6E, #4A4F9E);
  /* Gradient colors */
  /* Button background color */
  color: white;
  width: 70px;
  border: none;
  padding: 8px 20px;
  margin-right: 2px;
  font-size: 13px;
  cursor: pointer;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* Optional shadow for depth */
}

.verification-button img {
  width: 18px;
  /* Adjust icon size */
  height: 18px;
}
</style>

<script>
import { getAntiData, joinActivity, getWechatAuth, getJSSDK, getTemplate, getScoreConfig, registerByOpenId } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      eno: "",
      antiCode: "",
      antiCodeResult: "",
      antiresult: "",
      getGift: true,
      deptId: 0,
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      activityRule: "",
      activityId: "",
      authCode: "",
      showScore: false,
      showRule: false
    }
  },
  methods: {
    showActivityRule() {
      this.showRule = true
    },
    showActivity() {
      this.showRule = false
    },
    async getResult() {
      await getAntiData(this.antiCode, this.eno).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          alert("防伪查询失败,请联系管理员");
        } else {
          this.antiCodeResult = data.data.code.replace(/(\w{4})(?=\w)/g, '$1 ')
          if(data.code == "300101" || data.code == "300102"){
            this.antiresult = "您所查询的境生之源产品为正品，请放心使用!"
          }else{
            this.antiresult = "您所查询的数码不存在，谨防仿冒！"
          }
          
          this.deptId = data.data.deptId
          console.log(this.deptId)
        }
      }).catch(err =>
        alert("查询异常，请联系管理员")
      )
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      sessionStorage.setItem("wechatAuth", true);
      getWechatAuth(encodeURIComponent(url), "wxc0571471f3bb3b8d", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getScoreConfig() {
      getScoreConfig(this.deptId).then(res => {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      })
    },
    async getTemplate() {
      await getTemplate(this.deptId).then(res => {
        if (res.data.data == null) {
          this.showScore = false
        } else {
          this.activityId = res.data.data.activityId;
          this.activityRule = res.data.data.activityRule;
          this.showScore = true
        }

      })
    },
    async getConfig() {
      await this.getResult()
      await this.getScoreConfig()
      await this.getTemplate();
      const wechatAuth = sessionStorage.getItem("wechatAuth");
      if (wechatAuth == "true") {
        await this.joinActivity()
        return;
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxc0571471f3bb3b8d").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async joinActivity() {
      this.isDisabled = true;
      if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
        this.getAuth()
        return;
      }
      await registerByOpenId(this.eno, this.authCode).then(res => {
        this.userToken = res.data.data.token;
      })


      const data = {
        code: this.antiCode,
        activityId: this.activityId,
        authCode: this.authCode,
        userToken: this.userToken
      }
      await joinActivity(data).then(res => {
        //alert(JSON.stringify(res));
        if (res.data.code == "200") {
          this.getGift = true;

        } else if (res.data.code == "500001") {
          this.getGift = false;
        } else {
          this.getGift = false;
          alert("参与活动异常，原因：" + res.data.message);
        }
      })
      this.isDisabled = false;
      sessionStorage.removeItem("wechatAuth");
    }
  },
  mounted: function () {
    this.getWxJs()
  },
  created: function () {
    const params = this.$route.query;
    this.eno = params.eno;
    this.antiCode = params.c;
    this.authCode = this.$route.query.wyAuthCode
    if (this.eno == "" || this.eno == undefined || this.antiCode == "" || this.antiCode == undefined) {
      alert("请在正确入口地址中输入防伪码进行查询")
    }
    if (this.authCode == "" || this.authCode == undefined) {
      this.getAuth()
      return
    }
    this.getConfig()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BoLangFeiLin/ScoreResult.vue